import BaseCommand from "./baseCommand";
import { DOCUMENTS } from "../constants";
import { DOCUMENT_BLOCKS } from "../components/DocumentV2/constants";
import { getComponentFromStore } from "../actions/DocumentActions/services";
import { updateCellData } from "../components/RevvTableV2/utils";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

const getTableforUpdatedCellData = (cellValue, section, componentMeta) => {
  const { data: tableData } = section;
  const { tableColId, tableRowId } = componentMeta;
  const updatedTableData = updateCellData(
    { ...tableData },
    tableRowId,
    tableColId,
    cellValue,
  );
  const updatedTableSection = {
    ...section,
    data: updatedTableData,
  };

  return updatedTableSection;
};

class UpdateEditorFromToolbarCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.unDoable = false;
  }

  execute() {
    const {
      componentMeta,
      editorState,
      updateActiveEditorState,
      section,
      updateSection,
      oldEditorState,
    } = this.componentData;

    const { blockType } = componentMeta;

    let oldSection = { ...section };

    let updatedSection = { ...section };

    if (
      section.type === DOCUMENT_COMPONENT_TYPES.HTML ||
      section.type === DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER
    ) {
      oldSection = {
        ...oldSection,
        data: oldEditorState.getCurrentContent(),
      };
      updatedSection = {
        ...updatedSection,
        data: editorState.getCurrentContent(),
        editorState,
      };
    } else if (section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
      updatedSection = getTableforUpdatedCellData(
        {
          data: editorState.getCurrentContent(),
          editorState,
        },
        { ...section, data: { ...section.data } },
        componentMeta,
      );

      // getting the old section for undo/redo purposes
      oldSection = getTableforUpdatedCellData(
        {
          data: oldEditorState.getCurrentContent(),
        },
        { ...section, data: { ...section.data } },
        componentMeta,
      );
    }

    this.componentData.oldSection = oldSection;

    // get header of the current content
    const firstBlock = editorState.getCurrentContent().getFirstBlock();
    updatedSection.header = firstBlock.getText().trim();
    if (firstBlock.getType().startsWith("header")) {
      updatedSection.label = firstBlock.getText().trim();
    } else {
      updatedSection.label = updatedSection.header;
    }

    // update redux
    updateActiveEditorState(editorState, componentMeta);

    if (blockType === DOCUMENT_BLOCKS.BODY) {
      updateSection(
        updatedSection,
        true,
        false,
        oldSection,
        false,
        null,
        false,
        componentMeta,
      );
    } else if (blockType === DOCUMENT_BLOCKS.HEADER) {
      const { headerId } = componentMeta;
      getComponentFromStore(headerId).then(component => {
        const headerComponent = {
          ...component.content,
          data: {
            ...component.content.data,
            header: {
              ...component.content.data.header,
              components: {
                ...component.content.data.header.components,
                [updatedSection.id]: {
                  ...component.content.data.header.components[
                    updatedSection.id
                  ],
                  content: updatedSection,
                },
              },
            },
          },
        };

        const oldHeaderComponent = {
          ...component.content,
          data: {
            ...component.content.data,
            header: {
              ...component.content.data.header,
              components: {
                ...component.content.data.header.components,
                [oldSection.id]: {
                  ...component.content.data.header.components[oldSection.id],
                  content: oldSection,
                },
              },
            },
          },
        };
        updateSection(
          headerComponent,
          true,
          false,
          { ...oldHeaderComponent },
          false,
          null,
          false,
          componentMeta,
        );
      });
    } else if (blockType === DOCUMENT_BLOCKS.FOOTER) {
      const { footerId } = componentMeta;
      getComponentFromStore(footerId).then(component => {
        const footerComponent = {
          ...component.content,
          data: {
            ...component.content.data,
            footer: {
              ...component.content.data.footer,
              components: {
                ...component.content.data.footer.components,
                [updatedSection.id]: {
                  ...component.content.data.footer.components[
                    updatedSection.id
                  ],
                  content: updatedSection,
                },
              },
            },
          },
        };

        const oldFooterComponent = {
          ...component.content,
          data: {
            ...component.content.data,
            footer: {
              ...component.content.data.footer,
              components: {
                ...component.content.data.footer.components,
                [oldSection.id]: {
                  ...component.content.data.footer.components[oldSection.id],
                  content: oldSection,
                },
              },
            },
          },
        };
        updateSection(
          footerComponent,
          true,
          false,
          { ...oldFooterComponent },
          false,
          null,
          false,
          componentMeta,
        );
      });
    } else if (blockType === DOCUMENT_BLOCKS.COVERPAGE) {
      const { coverpageId } = componentMeta;
      getComponentFromStore(coverpageId).then(component => {
        let coverpageComponent = component;
        coverpageComponent = {
          ...coverpageComponent.content,
          data: {
            ...coverpageComponent.content.data,
            components: {
              ...coverpageComponent.content.data.components,
              [updatedSection.id]: {
                ...coverpageComponent.content.data.components[
                  updatedSection.id
                ],
                content: updatedSection,
              },
            },
          },
        };
        const oldCoverpageComponent = {
          ...component.content,
          data: {
            ...component.content.data,
            components: {
              ...component.content.data.components,
              [oldSection.id]: {
                ...component.content.data.components[oldSection.id],
                content: oldSection,
              },
            },
          },
        };
        updateSection(
          coverpageComponent,
          true,
          false,
          {
            ...oldCoverpageComponent,
          },
          false,
          null,
          false,
          componentMeta,
        );
      });
    }
  }

  undo() {
    console.debug("undo", this.componentData);
  }
}
export default UpdateEditorFromToolbarCommand;
